import { useTranslation } from "@/hooks/useTranslation"
import { Code } from "@/molecules/Code"
import { getFoundryDemoCommands } from "./helpers"

import type { FoundryDemoGrantProps } from "./FoundryTab.types"

export const FoundryDemoGrant = ({ subscriptionId }: FoundryDemoGrantProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "deployments.foundry.cloud.commands"
  })
  const commands = getFoundryDemoCommands(subscriptionId)

  return (
    <Code.CommandCard>
      {(["servicePrincipal", "roleAssignment"] as const).map((command) => (
        <Code.CommandSnippet
          key={command}
          comment={t(command)}
          instruction=""
          commands={commands[command]}
          copyText={commands[command]}
        />
      ))}
    </Code.CommandCard>
  )
}
